import UserService from "services/user.service";
import Banner from "./components/Banner";
import General from "./components/General";
import Notification from "./components/Notification";
import Project from "./components/Project";
import Storage from "./components/Storage";
import Upload from "./components/Upload";
import { useEffect, useState } from "react";

const ProfileOverview = () => {
  const [data, setData] = useState([]);

  const getUserDetails = async () => {
    try {
      const body = {
        id: "670177bb4cdd43ef86cce083",
      };
      const response = await UserService.getUserDetails(body);
      setData(response.data);
    } catch (error) {}
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  return (
    <div className="flex w-full flex-col gap-5">
      <div className="w-ful mt-3 flex h-fit flex-col gap-5 lg:grid lg:grid-cols-12">
        <div className="col-span-4 lg:!mb-0">
          <Banner data={data} />
        </div>
      </div>
      <div className="grid h-full grid-cols-1 gap-5 lg:!grid-cols-12">
        <div className="col-span-5 lg:col-span-6 lg:mb-0 3xl:col-span-4">
          <Project data={data} />
        </div>
        <div className="col-span-5 lg:col-span-6 lg:mb-0 3xl:col-span-5">
          <General data={data} />
        </div>
      </div>
    </div>
  );
};

export default ProfileOverview;
